module.exports = __webpack_public_path__ + "img/logo_svip.7eb63a70.png";